import React, { useState, useEffect } from "react";
import './CalendarCard.css';
import moment from 'moment-timezone';
import { format, parse } from 'date-fns';


const CalendarCard = () => {
    const [timeDetails, setTimeDetails] = useState(null);
    const [raguKuligaiEmakandam, setRaguKuligaiEmakandam] = useState(null);
    const [selectedNewDate, setSelectedNewDate] = useState(moment().tz("Asia/Kolkata"));
    const [rasiBoxDetails, setRasiBoxDetails] = useState(null);
    const dateInputRef = React.useRef(null);
    const [minDate, setMinDate] = useState(null);
    const [maxDate, setMaxDate] = useState(null);
    const [loading, setLoading] = useState(true);

    const [popup, setPopup] = useState({ show: false, text: '', index: null });

    const showPopup = (text, index) => {
        setPopup({ show: true, text, index });

        // Hide after 1 second
        setTimeout(() => {
            setPopup({ show: false, text: '', index: null });
        }, 1000);
    };

    const clearAllDetails = () => {
        setLoading(true);
        setTimeDetails(null);
        setRaguKuligaiEmakandam(null);
        setRasiBoxDetails(null);
    };

    const getNameByImage = {
        "/blackmoon.png": "అమావాస్య",
        "/fullmoon.png": "పూర్ణిమ",
        "/ekadasi.png": "ఏకాదశి",
        "/shasti.png": "షష్ఠి",
        "/sankataharachaturti.png": "సంకటహర చతుర్థి",
        "/shivaratri.png": "శివరాత్రి",
        "/pirathoosam.png": "ప్రదోష",
        "/chaturthi.png": "చవితి"
    }

    function get_samaskirtham(str) {

        if (str === ("ఆదివారము")) {
            return "భాను వాసరః";
        } else if (str === ("సోమవారము")) {
            return "ఇందు వాసరః";
        } else if (str === ("మంగళవారము")) {
            return "భౌమ వాసరః";
        } else if (str === ("బుధవారము")) {
            return "సౌమ్య వాసరః";
        } else if (str === ("గురువారము")) {
            return "బృహస్పతి వాసరః";
        } else if (str === ("శుక్రవారము")) {
            return "భృగు వాసరః";
        } else if (str === ("శనివారము")) {
            return "స్థిర వాసరః";
        } else {
            return "";
        }
    }



    function getVirathamImage(str) {

        if (str.includes("అమావాస్య")) {
            return "/blackmoon.png";
        }

        else if (str.includes("పూర్ణిమ")) {
            return "/fullmoon.png";
        }
        else if (str.includes("పౌర్ణమి")) {
            return "/fullmoon.png";
        }

        else if (str.includes("ఏకాదశి")) {
            return "/ekadasi.png";
        }

        else if (str.includes("షష్ఠి") || str.includes("షష్టి")) {
            return "/shasti.png";
        }

        else if (str.includes("సంకటహర చతుర్థి")) {
            return "/sankataharachaturti.png";
        }

        else if (str.includes("శివరాత్రి")) {
            return "/shivaratri.png";
        }

        else if (str.includes("ప్రదోష")) {
            return "/pirathoosam.png";
        }

        else if (str.includes("చవితి")) {
            return "/chaturthi.png";
        }

        return null;
    }

    function dateCange(inputDate) {
        var parsed = parse(inputDate, "d/m/yyyy", new Date());

        // Format to yyyy-MM-dd
        return format(parsed, "yyyy-mm-dd");

    }


    useEffect(() => {
        getDetails();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    const handleIconClick = () => {
        dateInputRef.current.showPicker?.();
        dateInputRef.current.click();
    };

    const handleDateChange = (e) => {
        const selectedDate = e.target.value;

        if (selectedDate) {
            const momentDate = moment(selectedDate).tz("Asia/Kolkata");
            setSelectedNewDate(momentDate)
            getNewDetails(selectedDate);
        }
    };
    const refreshDate = () => {
        const momentDate = moment().tz("Asia/Kolkata");
        setSelectedNewDate(momentDate)
        getDetails();

    }
    const handlePrevious = () => {
        const newDate = selectedNewDate.clone().subtract(1, "day");
        setSelectedNewDate(newDate);
        getNewDetails(newDate.format("YYYY-MM-DD"));
    };

    const handleNext = () => {
        const newDate = selectedNewDate.clone().add(1, "day");
        setSelectedNewDate(newDate);
        getNewDetails(newDate.format("YYYY-MM-DD"));
    };
    const getNewDetails = async (selectedDate) => {
        clearAllDetails();
        const [year] = selectedDate.split("-");
        const dayOfWeek = moment(selectedDate).tz("Asia/Kolkata").day();
        fetchGoodTime(selectedDate);
        fetchRaguKuligaiEmakandam(year, dayOfWeek);
        // console.log("formattedDate...", selectedDate);
        fetchRasiBoxDetails(selectedDate);
    };
    const getDetails = async () => {
        const today = moment().tz('Asia/Kolkata');
        const today_formattedDate = today.format('YYYY-MM-DD');
        fetchDateLimt();
        fetchGoodTime(today_formattedDate);
        fetchRaguKuligaiEmakandam(today.year(), today.day());
        fetchRasiBoxDetails(today.format('YYYY-MM-DD'));
    };
    const fetchDateLimt = async () => {
        // Gets the month (0-11), so add 1
        const url = `${process.env.REACT_APP_SERVERURL}/get_date_limit`;
        fetch(url)
            .then((response) => {
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                return response.json();
            })
            .then((data) => {
                // console.log("day... startdate enddate", data);
                if (data && data.length > 0) { // store the first record
                    setMaxDate(dateCange(data[0].endDate));
                    setMinDate(dateCange(data[0].startDate));// store the first record
                    // console.log("minDate", dateCange(data[0].startDate));
                    // console.log("maxDate", dateCange(data[0].endDate));
                } else {
                    setMinDate(null);
                    setMaxDate(null);  // no record found
                }
            })
            .catch((error) => {
                console.error('Error fetching data:', error);
                setMinDate(null);
                setMaxDate(null); // fallback in case of error
            });
    };

    const fetchGoodTime = async (todayDate) => {
        // Gets the month (0-11), so add 1
        // console.log("tttttt", todayDate);
        const url = `${process.env.REACT_APP_SERVERURL}/get_time_details?date=${todayDate}`;
        fetch(url)
            .then((response) => {
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                return response.json();
            })
            .then((data) => {

                //console.log("time... details", data);
                if (data && data.length > 0) {
                    setTimeDetails(data[0]);
                    setLoading(false)

                } else {
                    setTimeDetails(null); // no record found
                }
            })
            .catch((error) => {
                console.error('Error fetching data:', error);
                setTimeDetails(null); // fallback in case of error
            });
    };

    const fetchRaguKuligaiEmakandam = async (year, dayOfWeekIndex) => {
        const tamilWeekDays = [
            "ఆదివారము", // Sunday
            "సోమవారము", // Monday
            "మంగళవారము", // Tuesday
            "బుధవారము", // Wednesday
            "గురువారము", // Thursday
            "శుక్రవారము", // Friday
            "శనివారము"    // Saturday
        ];
        const tamilWeekDay = tamilWeekDays[dayOfWeekIndex];
        const url = `${process.env.REACT_APP_SERVERURL}/get_ragu_kuligai_details?year=${year}&weekday=${tamilWeekDay}`;
        fetch(url)
            .then((response) => {
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                return response.json();
            })
            .then((data) => {

                //console.log("time... details", data);
                if (data && data.length > 0) {
                    setRaguKuligaiEmakandam(data[0]); // store the first record
                } else {
                    setRaguKuligaiEmakandam(null); // no record found
                }
            })
            .catch((error) => {
                console.error('Error fetching data:', error);
                setRaguKuligaiEmakandam(null); // fallback in case of error
            });
    };

    const fetchRasiBoxDetails = async (todayDate) => {
        const url = `${process.env.REACT_APP_SERVERURL}/get_rasi_box_details?date=${todayDate}`;
        fetch(url)
            .then((response) => {
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                return response.json();
            })
            .then((data) => {
                setLoading(false);
                // console.log("box... details", data);
                if (data && data.length > 0) {
                    setRasiBoxDetails(data[0]); // store the first record
                } else {
                    setRasiBoxDetails(null); // no record found
                }
            })
            .catch((error) => {
                console.error('Error fetching data:', error);
                setRasiBoxDetails(null); // fallback in case of error
            });
    };


    const specialValues = [
        timeDetails?.Festivals,
        timeDetails?.importan_days,
    ].filter(value => value && value.trim() !== '-');


    if (loading) {
        return (
            <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '300px' }}>
                <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
            </div>
        );
    }

    return (
        <div className="container my-3 calendar-wrapper">
            {/* Header */}
            <div className="d-flex justify-content-between align-items-center header-bar p-2 shadow-sm rounded">
                <div className="header-title fw-bold" style={{ color: "#e53935" }}>
                    <div style={{ paddingTop: '5px' }}>
                        రోజువారీ క్యాలెండర్</div></div>

                <div className="d-flex gap-2 header-icons">
                    <i
                        className="bi bi-arrow-clockwise"
                        style={{ cursor: "pointer" }}
                        onClick={refreshDate}
                    />
                    <div>

                    </div>
                    <i
                        className="bi bi-calendar"
                        style={{ cursor: "pointer" }}
                        onClick={handleIconClick}
                    />
                    <input
                        ref={dateInputRef}
                        type="date"
                        min={minDate}
                        max={maxDate}
                        value={selectedNewDate.format("YYYY-MM-DD")}
                        style={{ display: "none" }}
                        onChange={handleDateChange}
                    />
                </div>
            </div>

            {/* Date Card */}

            <div className="date-card my-2 text-center rounded shadow-sm p-3 d-flex justify-content-between align-items-center">
                {selectedNewDate.format("YYYY-MM-DD") !== minDate ?
                    <i
                        className="bi bi-chevron-left fs-4 text-white"
                        style={{ cursor: "pointer" }}
                        onClick={handlePrevious}
                    />
                    : <i className="bi bi-chevron-left fs-4" style={{ cursor: "not-allowed", color: "#e53935" }} />
                }
                {timeDetails && (
                    <div>
                        <div className="fw-bold" >{timeDetails.month} - {timeDetails.weekday}</div>
                        <div className="fw-bold">{get_samaskirtham(timeDetails.weekday)}</div>
                        <h2 className="date-text m-0">{timeDetails.date.replace(/\//g, '-')}</h2>
                        <div>{timeDetails.teluguYearname} <br /> {timeDetails.telugu_month} <br /> {timeDetails.ruthulu} <br /> {timeDetails.ayanam}</div>
                    </div>
                )}
                {selectedNewDate.format("YYYY-MM-DD") !== maxDate ?
                    <i
                        className="bi bi-chevron-right fs-4 text-white"
                        style={{ cursor: "pointer" }}
                        onClick={handleNext}
                    />
                    : <i className="bi bi-chevron-right fs-4" style={{ cursor: "not-allowed", color: "#e53935" }} />
                }

            </div>


            {/* Special Note */}
            <div
                style={{
                    backgroundColor: '#f5f5f5',
                    padding: '8px',
                    textAlign: 'center',
                    borderRadius: '4px',
                }}>
                {timeDetails?.Holiday_Flag === "1" && (
                    <div className=" text-center py-1" style={{ color: 'red', fontSize: '25px' }}>
                        ప్రభుత్వ సెలవుదినం
                    </div>
                )}


                <div className="timing-card my-3 border rounded shadow-sm overflow-hidden ">
                    {/* Create finalVirathamString */}
                    {timeDetails?.viratha_days &&
                        timeDetails.viratha_days.replace(/-/g, '').trim().length > 0 && (
                            <div className="row text-center text-white header-row py-1">
                                <div
                                    className="card-header red-header"
                                    style={{
                                        paddingLeft: '1rem',
                                        paddingRight: '1rem',
                                        fontSize: '20px',
                                    }}
                                >

                                    <div style={{ paddingTop: '10px' }}>{timeDetails.viratha_days}</div>
                                </div>
                            </div>
                        )}



                    {timeDetails?.viratha_days &&
                        timeDetails.viratha_days.replace(/-/g, '').trim().length > 0 && (

                            <div className="moon-icon text-center">
                                {getVirathamImage(timeDetails.viratha_days) && (

                                    <div style={{ position: 'relative', display: 'inline-block' }}>
                                            {popup.show && popup.index === "101" && (
                                                <div style={{
                                                    position: 'absolute',
                                                    top: '50%',
                                                    left: '-80%', // Push it to the right of the image
                                                    transform: 'translateY(-50%)', // Vertically center it
                                                    backgroundColor: '#333',
                                                    color: '#fff',
                                                    padding: '5px 10px',
                                                    borderRadius: '4px',
                                                    fontSize: '12px',
                                                    whiteSpace: 'nowrap',
                                                    zIndex: 1000,
                                                    boxShadow: '0 2px 6px rgba(0, 0, 0, 0.3)',
                                                }}>
                                                    {popup.text}
                                                </div>
                                            )}
                                            <img src={getVirathamImage(timeDetails.viratha_days)} alt="" height={40} 
                                                style={{ cursor: 'pointer' }}
                                                onClick={() => showPopup(getNameByImage[getVirathamImage(timeDetails.viratha_days)], "101")}
                                                onMouseOver={() => showPopup(getNameByImage[getVirathamImage(timeDetails.viratha_days)], "101")}></img>
                                        </div>
                                )}
                            </div>
                        )}


                    {specialValues.length > 0 && (
                        <div>
                            {timeDetails.viratha_days.replace(/-/g, '').trim().length > 0 && (
                                <div className="dotted-line"></div>
                            )}
                            <div style={{ paddingTop: '10px', fontSize: '20px' }} className="text-center">
                                {specialValues.join(', ')}
                            </div>
                        </div>
                    )}
                </div>

                {/* Timings */}
                {timeDetails && (
                    <div className="timing-card my-3 border rounded shadow-sm overflow-hidden ">
                        <div className="row text-center  header-row py-1">
                            <div className="card-header">
                                <div className="row text-center body-row">
                                    <div className="col text-white" style={{ paddingTop: '10px', fontSize: '20px' }}>సూర్యోదయం</div>
                                    <div className="col text-white" style={{ paddingTop: '10px', fontSize: '20px' }}>సూర్యాస్తమయం</div>
                                </div>
                            </div>


                        </div>
                        <div className="row text-center body-row ">
                            <div className="col border-end" style={{ paddingTop: '10px', fontSize: '23px' }}>{timeDetails.suriya_udhayam}</div>
                            <div className="col" style={{ paddingTop: '10px', fontSize: '23px' }}>{timeDetails.suriya_ashtham}</div>
                        </div>
                    </div>
                )}
                {timeDetails && (
                    <div className="timing-card my-3 border rounded shadow-sm overflow-hidden">
                        <div className="row text-center body-row py-1 ">
                            <div className="col border-end">
                                <div className="pink-title" style={{ paddingTop: '10px', fontSize: '23px' }}>తిథి</div>
                                <div className="" style={{ paddingTop: '10px', fontSize: '23px' }}>{timeDetails.Thithi}</div>

                            </div>
                            <div className="col">
                                <div className="pink-title" style={{ paddingTop: '10px', fontSize: '23px' }}>నక్షత్రం</div>
                                <div className="" style={{ paddingTop: '10px', fontSize: '23px' }}>{timeDetails.Nakshatra}</div>
                            </div>

                        </div>

                        <div className="dotted-line"></div>

                        <div className="row text-center body-row py-1 ">
                            <div className="col border-end">
                                <div className="pink-title" style={{ paddingTop: '10px', fontSize: '23px' }}>యోగం</div>
                                <div className="" style={{ paddingTop: '10px', fontSize: '23px' }}>{timeDetails.yoga}</div>

                            </div>
                            <div className="col">
                                <div className="pink-title" style={{ paddingTop: '10px', fontSize: '23px' }}>కరణం</div>
                                <div className="" style={{ paddingTop: '10px', fontSize: '23px' }}>{timeDetails.karan}</div>
                            </div>

                        </div>

                        <div className="dotted-line"></div>
                    </div>
                )}

                {timeDetails &&
                    timeDetails.subha_time.replace(/-/g, '').trim().length > 0 && (
                        <div className="timing-card my-3 border rounded shadow-sm overflow-hidden ">
                            <div className="row text-center  header-row py-1">
                                <div className="card-header">
                                    <div className="row text-center body-row">
                                        <div className="col text-white" style={{ paddingTop: '10px', fontSize: '20px' }}>శుభ సమయములు</div>

                                    </div>
                                </div>


                            </div>
                            <div className="row text-center body-row ">
                                <div className="col" style={{ paddingTop: '10px', fontSize: '23px' }}>{timeDetails.subha_time }</div>

                            </div>
                        </div>
                    )}


                {raguKuligaiEmakandam && (
                    <div className="timing-card my-3 border rounded shadow-sm overflow-hidden ">
                        <div className="row text-center  header-row py-1">
                            <div className="card-header">
                                <div className="row text-center body-row">
                                    <div className="col text-white" style={{ paddingTop: '10px', fontSize: '20px' }}>రాహుకాలం</div>
                                    <div className="col text-white" style={{ paddingTop: '10px', fontSize: '20px' }}>యమగండం</div>
                                </div>
                            </div>


                        </div>
                        <div className="row text-center body-row ">
                            <div className="col border-end" style={{ paddingTop: '10px', fontSize: '23px' }}>{raguKuligaiEmakandam?.ragu}</div>
                            <div className="col" style={{ paddingTop: '10px', fontSize: '23px' }}>{raguKuligaiEmakandam?.emakandam}</div>
                        </div>
                    </div>
                )}

                {timeDetails &&
                    timeDetails.subha_time.replace(/-/g, '').trim().length > 0 && (
                        <div className="timing-card my-3 border rounded shadow-sm overflow-hidden ">
                            <div className="row text-center  header-row py-1">
                                <div className="card-header">
                                    <div className="row text-center body-row">
                                        <div className="col text-white" style={{ paddingTop: '10px', fontSize: '20px' }}>దుర్ముహూర్తం</div>

                                    </div>
                                </div>


                            </div>
                            <div className="row text-center body-row ">
                                <div className="col" style={{ paddingTop: '10px', fontSize: '23px' }}>{timeDetails.durmuhurtalu }</div>

                            </div>
                        </div>
                    )}

                {timeDetails &&
                    timeDetails.subha_time.replace(/-/g, '').trim().length > 0 && (
                        <div className="timing-card my-3 border rounded shadow-sm overflow-hidden ">
                            <div className="row text-center  header-row py-1">
                                <div className="card-header">
                                    <div className="row text-center body-row">
                                        <div className="col text-white" style={{ paddingTop: '10px', fontSize: '20px' }}>వర్జము</div>
                                        <div className="col text-white" style={{ paddingTop: '10px', fontSize: '20px' }}>అమృత<br />ఘడియలు</div>

                                    </div>
                                </div>


                            </div>
                            <div className="row text-center body-row ">
                                <div className="col" style={{ paddingTop: '10px', fontSize: '23px' }}>{timeDetails.Varjam}</div>
                                <div className="col" style={{ paddingTop: '10px', fontSize: '23px' }}>{timeDetails.amrutha_gadiyalu}</div>
                            </div>
                        </div>
                    )}

                {rasiBoxDetails === null ? (
                    <div className="text-center">No Kocharam Details Available</div>
                ) :
                    <div className="timing-card my-3 border rounded shadow-sm overflow-hidden ">
                        <div className="row text-center text-white header-row py-1">
                            <div
                                className="card-header red-header"
                                style={{
                                    paddingLeft: '1rem',
                                    paddingRight: '1rem',
                                    fontSize: '20px',
                                }}
                            >

                                <div style={{ paddingTop: '10px' }}>రాశి చక్రం</div>
                            </div>
                        </div>

                        <div style={{ paddingTop: "10px" }}>
                            <div className="horoscope-grid mx-auto">
                                {/* First row */}
                                <div className="cell" style={{
                                fontSize: '20px',
                            }} >
                                    {rasiBoxDetails.c1 && rasiBoxDetails.c1.trim() !== '-'
                                        ? rasiBoxDetails.c1
                                        : ''}
                                </div>
                                <div className="cell" style={{
                                fontSize: '20px',
                            }}>
                                    {rasiBoxDetails.c2 && rasiBoxDetails.c2.trim() !== '-'
                                        ? rasiBoxDetails.c2
                                        : ''}
                                </div>

                                <div className="cell" style={{
                                fontSize: '20px',
                            }}>
                                    {rasiBoxDetails.c3 && rasiBoxDetails.c3.trim() !== '-'
                                        ? rasiBoxDetails.c3
                                        : ''}
                                </div>

                                <div className="cell" style={{
                                fontSize: '20px',
                            }}>
                                    {rasiBoxDetails.c4 && rasiBoxDetails.c4.trim() !== '-'
                                        ? rasiBoxDetails.c4
                                        : ''}
                                </div>

                                {/* Second row */}
                                <div className="cell" style={{
                                fontSize: '20px',
                            }}>
                                    {rasiBoxDetails.c12 && rasiBoxDetails.c12.trim() !== '-'
                                        ? rasiBoxDetails.c12
                                        : ''}
                                </div>
                                <div className="cell center-content span-row-2 span-col-2">
                                    {rasiBoxDetails.date && rasiBoxDetails.date.trim() !== '-' && (
                                        <div style={{
                                fontSize: '20px',
                            }}>
                                            {rasiBoxDetails.date}
                                        </div>
                                    )}

                                    

                                </div>
                                <div className="cell" style={{
                                fontSize: '20px',
                            }}>
                                    {rasiBoxDetails.c5 && rasiBoxDetails.c5.trim() !== '-'
                                        ? rasiBoxDetails.c5
                                        : ''}
                                </div>
                                {/* Third row */}

                                <div className="cell" style={{
                                fontSize: '20px',
                            }}>
                                    {rasiBoxDetails.c11 && rasiBoxDetails.c11.trim() !== '-'
                                        ? rasiBoxDetails.c11
                                        : ''}
                                </div>
                                <div className="cell" style={{
                                fontSize: '20px',
                            }}>
                                    {rasiBoxDetails.c6 && rasiBoxDetails.c6.trim() !== '-'
                                        ? rasiBoxDetails.c6
                                        : ''}
                                </div>

                                {/* Fourth row - 4 empty cells */}
                                <div className="cell" style={{
                                fontSize: '20px',
                            }}>
                                    {rasiBoxDetails.c10 && rasiBoxDetails.c10.trim() !== '-'
                                        ? rasiBoxDetails.c10
                                        : ''}
                                </div>
                                <div className="cell" style={{
                                fontSize: '20px',
                            }}>
                                    {rasiBoxDetails.c9 && rasiBoxDetails.c9.trim() !== '-'
                                        ? rasiBoxDetails.c9
                                        : ''}
                                </div>
                                <div className="cell" style={{
                                fontSize: '20px',
                            }}>
                                    {rasiBoxDetails.c8 && rasiBoxDetails.c8.trim() !== '-'
                                        ? rasiBoxDetails.c8
                                        : ''}
                                </div>
                                <div className="cell" style={{
                                fontSize: '20px',
                            }}>
                                    {rasiBoxDetails.c7 && rasiBoxDetails.c7.trim() !== '-'
                                        ? rasiBoxDetails.c7
                                        : ''}
                                </div>
                            </div>
                        </div>
                    </div>
                }

                <div className="timing-card my-3 border rounded shadow-sm overflow-hidden ">
                    <div className="row text-center text-white header-row py-1">
                        <div
                            className="card-header red-header"
                            style={{
                                paddingLeft: '1rem',
                                paddingRight: '1rem',
                                fontSize: '20px',
                            }}
                        >

                            <div style={{ paddingTop: '10px' }}>మంగళం మహత్<br />శ్రీ శ్రీ శ్రీ శ్రీ శ్రీ</div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    );
};

export default CalendarCard;
